import Nullable = Common.Nullable;

export function getSessionStorageValue<T = string>(key: string): Nullable<T> {
  const rawValue = sessionStorage.getItem(key);

  if (rawValue === null) return null;

  try {
    return JSON.parse(rawValue);
  } catch (e) {
    console.warn(`Error parsing key "${key}":`, e);

    return null;
  }
}

export function setSessionStorageValue<T>(key: string, value: T): void {
  try {
    const stringified = JSON.stringify(value);

    sessionStorage.setItem(key, stringified);
  } catch (e) {
    console.error(`Error saving sessionStorage key "${key}":`, e);
  }
}
